module.exports = { id: "home", url: "/build/app/img/symbols.svg#home", viewBox: "", toString: function() { return this.url; } };